import paper from 'paper';

class CanvasManager {
  initialize(canvas) {
    paper.setup(canvas);
  }

  loadSVG(svgPath) {
    return new Promise((resolve, reject) => {
      paper.project.importSVG(svgPath, {
        onLoad: resolve,
        onError: reject,
      });
    });
  }

  scaleSVG(canvasContainerEl, svgObj, canvasEl) {
    const { height, width } = canvasEl
      ? canvasEl.getBoundingClientRect()
      : canvasContainerEl.getBoundingClientRect();
    const mask = new paper.Rectangle(
      0,
      0,
      width + (20 / 100) * width,
      height + (20 / 100) * height
    );

    svgObj.fitBounds(mask);
  }
}

export default CanvasManager;
